import React, { useState } from "react";
import Loading from "../../error/Loading";
import { ToastContainer, toast } from "react-toastify";
import { AuthAPI } from "../../../services/dbApi";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const LoginComponent = ({ setIsLoggedIn, setUserName }) => {
  useEffect(() => {
    AuthAPI.sessionStatus()
      .then(async (res) => {
        if (res.data.valid) {
          const lobRes = await AuthAPI.getLobList();
          setLobList(lobRes.data);
          setStep(3);
        } else {
          setStep(1);
        }
      })
      .finally(() => {
        setCheckingSession(false);
      });
  }, []);

  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState(1);

  const [email, setEmail] = useState("");
  const [emailOtp, setEmailOtp] = useState("");

  const [lobList, setLobList] = useState([]);
  const [gstList, setGstList] = useState([]);

  const [selectedLob, setSelectedLob] = useState("");
  const [selectedGst, setSelectedGst] = useState("");

  const [gstOtpSent, setGstOtpSent] = useState(false);
  const [gstOtp, setGstOtp] = useState("");

  const [showGstPopup, setShowGstPopup] = useState(false);

  const [otpLogId, setOtpLogId] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [otpValidDays, setOtpValidDays] = useState(null);

  const navigate = useNavigate();

  /* Load GST when LOB selected */
  const handleLobChange = async (lob) => {
    setSelectedLob(lob);
    setSelectedGst("");
    setGstList([]);

    if (!lob) return;

    try {
      const res = await AuthAPI.getGstList(lob);
      setGstList(res.data); // array of GSTIN
    } catch {
      toast.error("Unable to load GST list");
    }
  };

  /* Submit handler */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      /* STEP 1 — SEND EMAIL OTP */
      if (step === 1) {
        await AuthAPI.sendEmailOtp({ email });

        toast.success("OTP sent");
        setStep(2);
      } else if (step === 2) {
        /* STEP 2 — VERIFY EMAIL OTP */
        const emailres = await AuthAPI.verifyEmailOtp({
          email,
          otp: emailOtp,
        });

        const lobRes = await AuthAPI.getLobList();
        setLobList(lobRes.data);

        toast.success("Email verified");
        setIsLoggedIn(true);
        setUserName(emailres.data.userName);
        setStep(3);
      } else if (step === 3 && !gstOtpSent) {
        /* STEP 3 — SEND GST OTP */
        if (!selectedLob || !selectedGst) {
          toast.error("Select LOB and GSTIN");
          setLoading(false);
          return;
        }

        const res = await AuthAPI.sendGstOtp({
          gstin: selectedGst,
          company_code: selectedLob,
        });

        toast.success("GST OTP sent");
        setOtpLogId(res.data.log_id);
        setGstOtpSent(true);
      } else if (step === 3 && gstOtpSent) {
        await AuthAPI.verifyGstOtp({
          gstin: selectedGst,
          otp: gstOtp,
          log_id: otpLogId,
        });

        setShowGstPopup(true);

        setTimeout(() => {
          setShowGstPopup(false);

          setSelectedGst("");
          setSelectedLob("");
          setGstOtp("");
          setGstOtpSent(false);

          setLoading(false);

          navigate("/Business-GSTIN-Verification");
        }, 2500);
      }

      setLoading(false);
    } catch (err) {
      const message = err?.response?.data?.message || "Internal Server Error";
      toast.error(message);

      if (message.includes("expired")) {
        setStep(1);
        setEmailOtp("");
      }
      setLoading(false);
    }
  };

  if (checkingSession || loading) {
    return <Loading />;
  }

  return (
    <div className="gst-page">
      <>
        <div className="box-login register-a">
          <ToastContainer />

          {showGstPopup && (
            <div className="popup-message">
              GST Session Updated Successfully
            </div>
          )}

          <div className="top-header">
            <h3>Business GSTIN Verification Login</h3>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              {/* EMAIL */}
              {step === 1 && (
                <div className="review-input-field">
                  <label>Email ID</label>
                  <input
                    type="email"
                    className="input-box"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              )}

              {/* EMAIL OTP */}
              {step === 2 && (
                <div className="review-input-field">
                  <label>Enter Email OTP</label>
                  <input
                    type="text"
                    className="input-box"
                    placeholder="Enter OTP"
                    maxLength={6}
                    minLength={6}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    required
                  />
                </div>
              )}

              {/* LOB & GST */}
              {step === 3 && (
                <>
                  <div className="review-input-field">
                    <label>Select LOB</label>
                    <select
                      className="input-box"
                      value={selectedLob}
                      onChange={(e) => handleLobChange(e.target.value)}
                      disabled={gstOtpSent}
                    >
                      <option value="">Select LOB</option>
                      {lobList.map((lob) => (
                        <option key={lob} value={lob}>
                          {lob}
                        </option>
                      ))}
                    </select>
                  </div>

                  {selectedLob && (
                    <div className="review-input-field">
                      <label>Select GSTIN</label>
                      <select
                        className="input-box"
                        value={selectedGst}
                        onChange={async (e) => {
                          const gst = e.target.value;

                          setSelectedGst(gst);

                          if (!gst) return;

                          try {
                            const res = await AuthAPI.gstOtpStatus(gst);

                            if (res.data.valid) {
                              setOtpValidDays(res.data.daysLeft);
                            } else {
                              setOtpValidDays(null);
                            }
                          } catch {
                            toast.error("Failed to check GST OTP status");
                          }
                        }}
                        disabled={gstOtpSent}
                      >
                        <option value="">Select GSTIN</option>
                        {gstList.map((gst) => (
                          <option key={gst.gstin} value={gst.gstin}>
                            {`${gst.valid ? "✅" : "🚫"} ${gst.gstin}  `}
                          </option>
                        ))}
                      </select>
                      {/* {selectedGst && (
                        <div className="gst-valid-info">
                          {otpValidDays ? (
                            <>
                              <div>GST OTP already verified.</div>

                              {otpValidDays <= 5 ? (
                                <span style={{ color: "red" }}>
                                  ❗ Expiring in next {otpValidDays} days
                                </span>
                              ) : (
                                <span style={{ color: "green" }}>
                                  Valid for next {otpValidDays} days
                                </span>
                              )}
                            </>
                          ) : (
                            <span
                              style={{
                                color: "red",
                                marginTop: "0px",
                                display: "inline-block",
                              }}
                            >
                              OTP Not Verified Please Verify
                            </span>
                          )}
                        </div>
                      )} */}
                      {selectedGst && (
                        <div className="gst-valid-info">
                          {otpValidDays ? (
                            <>
                              <div>GSTIN OTP Already Verified.</div>

                              {otpValidDays <= 5 ? (
                                <span style={{ color: "red" }}>
                                  ❗ Expiring In Next {otpValidDays} Days
                                </span>
                              ) : (
                                <span style={{ color: "green" }}>
                                  Valid For Next {otpValidDays} Days
                                </span>
                              )}
                            </>
                          ) : gstOtpSent ? (
                            <span style={{ color: "orange" }}>
                              OTP Sent Valid For 5 Minutes.
                            </span>
                          ) : (
                            <span style={{ color: "red" }}>
                              OTP Not Verified Please Verify
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {gstOtpSent && (
                    <div className="review-input-field">
                      <label>Enter GST OTP</label>
                      <input
                        className="input-box"
                        placeholder="Enter OTP"
                        maxLength={6}
                        minLength={6}
                        value={gstOtp}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onChange={(e) => setGstOtp(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </>
              )}

              <div className="input-field">
                <input
                  type="submit"
                  className="input-submit"
                  value={
                    step === 1
                      ? "Send OTP "
                      : step === 2
                        ? "Verify OTP"
                        : step === 3 && !gstOtpSent
                          ? "Send GST OTP"
                          : "Verify GST OTP"
                  }
                />
              </div>
            </div>
          </form>
        </div>
        {/* )} */}
      </>
    </div>
  );
};

export default LoginComponent;
